import { Component, OnInit } from '@angular/core';

import { AlertController, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { CandidatoService } from './services/candidato.service';
import { SituacaoEnum } from 'src/app/enums/situacao.enum';
import { Candidato } from 'src/app/interfaces/candidato';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit{
  routerLogin = '/tabs/perfil-usuario';
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private candidatoService: CandidatoService,
    private alertCtrl: AlertController,
    private swUpdate: SwUpdate
  ) {
    this.initializeApp();
  }

  async initializeApp() {
    this.platform.ready().then(async () => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      // Vamos carregar o usuário logado
      await this.candidatoService.atualizaCandidatoLogado();
    });
    this.checkForUpdate();
  }

  ngOnInit(): void {
    this.candidatoService.candidato$
      .subscribe(
        (candidato: Candidato) => {
          if (candidato && candidato.situacao === SituacaoEnum.finalizado) this.routerLogin = `/tabs/perfil-usuario`
        }
      );
  }

  checkForUpdate() {
    // tslint:disable-next-line:no-console
    console.info('check for update sem refresh');
    this.swUpdate.available.subscribe(event => {
      this.confirmUpdateApp();
      // tslint:disable-next-line:no-console
      console.info('current version is ', event.current, ' available version is ', event.available);
    });
    this.swUpdate.activated.subscribe(event => {
      // tslint:disable-next-line:no-console
      console.info('old version was ', event.current, ' new version is ', event.previous);
    });
  }

  async confirmUpdateApp() {
    const alert = await this.alertCtrl.create({
      header: 'Atualizar aplicação',
      message: 'Existe uma nova versão disponível, deseja atualizar?',
      cssClass: 'alert-primary',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sim',
          handler: () => {
            window.location.href = window.location.href + '?d=' + new Date().getTime();
            window.location.reload();
          }
        }
      ]
    });
    await alert.present();
  }
}
